<h2 mat-dialog-title>Edit Product</h2>
<mat-dialog-content>
  <app-data-access-products [id]="id" [mode]="'edit'"></app-data-access-products>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="cancel()">Cancel</button>
  <button mat-flat-button color="primary" (click)="save()">Save</button>
</mat-dialog-actions>
